import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AccessGate } from './auth/AccessGate';
import { AuthProvider } from './auth/AuthContext';
import { I18nProvider } from './i18n/I18nContext';
import { App } from './App';
import './styles/app.css';

// Einstiegspunkt der SPA: React übernimmt das Element #root aus index.html.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nProvider>
      <AccessGate>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </AccessGate>
    </I18nProvider>
  </React.StrictMode>
);
